import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import { limpiarFiltros } from '../../actions/generalActios';
import { fetchSellersFilter } from '../../actions/sellersActions';
import { fetchOrdenesEncabezado, setFiltroOrdenes, resetOrdenes } from '../../actions/ordenesActions';
import OrdenListItem from './OrdenListItem';
import FiltroOrdenes from './FiltroOrdenes';
import BigSpinner from "../General/BigSpinner";
import BtnToggleFilter from "../General/Filter/BtnToggleFilter";
import { filtroUnaSemana } from '../../utilities/fechasFiltro';
import { formatoDecimal } from '../../utilities/formatoNumeros';
import { withNavigation } from '../General/withNavigation';
import UploadFileOrdenes from '../General/UploadFileOrdenes';
import { fileToBase64 } from '../../utilities/formatFile';
import { postCargaMasivaComprobantesApi } from '../../api/axios';
import { toast } from 'react-toastify';
const fechaFiltro = filtroUnaSemana();

// Wrapper para usar hooks en class component
function ListOrdenesWrapper(props) {
    const navigate = useNavigate();
    return <ListOrdenes {...props} navigate={navigate} />;
}

class ListOrdenes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            onFilter: true,
            request: {
                idSeller: this.props.idSeller,
                numeroPagina: this.props.numeroPagina ? this.props.numeroPagina : 1,
                cantidadPagina: 10,
                documento: "",
                idOrden: "",
                nombre: "",
                apellido: "",
                fechaDesde: fechaFiltro.desde,
                fechaHasta: fechaFiltro.hasta,
                skuMarket: "",
                desdePublicacion: false
            }
        };
        const { isCategory, isSoloLectura, isAdminMod } = this.props.userType;
        this.allowSearchBySeller = isCategory || isSoloLectura || isAdminMod;
    }

    componentDidMount() {
        // Only use cached data if NO custom filter is active.
        // If coming from Dashboard (emptyFiltro.ordenes = false), we must fetch.
        if (this.props.ordenes?.elementos?.length > 0 && this.props.emptyFiltro.ordenes) {
            return;
        }

        let estadoInicioFiltraPor_Moderador = { ...this.state.request, idSeller: "" };
        let request = this.props.filtro;

        if (this.props.emptyFiltro.ordenes) {
            //Si el filtro de ordenes esta vacio, pero en this.propos.filtro tengo el skuMarket,
            //es porque vengo de seleccionar una publicacion para ver sus ordenes

            if (request.desdePublicacion) {
                // vengo con un skuMarket desde Publicaciones
                this.setState({ onFilter: false })
                request = this.state.request;
                request.idSeller = "";
                request.numeroPagina = 1;
                request.skuMarket = this.props.filtro.skuMarket;
                request.fechaDesde = this.props.filtro.fechaDesde;
                request.desdePublicacion = this.props.filtro.desdePublicacion;

                this.props.setFiltroOrdenes(request);
                this.setState({ request: request });
                this.props.fetchOrdenesEncabezado(request);

            } else {
                if (this.allowSearchBySeller) {
                    estadoInicioFiltraPor_Moderador.desdePublicacion = false;
                    this.props.setFiltroOrdenes(estadoInicioFiltraPor_Moderador);
                    this.setState({ request: estadoInicioFiltraPor_Moderador })
                    this.props.fetchOrdenesEncabezado(estadoInicioFiltraPor_Moderador);
                } else {
                    this.props.setFiltroOrdenes(this.state.request);
                    this.props.fetchOrdenesEncabezado(this.state.request);
                }
            }

        } else {

            request.numeroPagina = 1;
            this.props.setFiltroOrdenes(request);
            this.setState({ request: request });
            this.props.fetchOrdenesEncabezado(request);
        }

        if (this.allowSearchBySeller) {
            //      this.props.fetchSellersFilter(null);
        }
    }

    onOrden = (id) => {

        let pathReturn = `/Ordenes`


        this.props.navigate({
            pathname: `/Ordenes/Editar/${id}`,
            state: pathReturn
        });
    }

    handlePageClick = (e) => {
        const selectedPage = e.selected + 1;

        const updatedFiltro = {
            ...this.props.filtro,
            numeroPagina: selectedPage,
        };

        this.props.setFiltroOrdenes(updatedFiltro);
        this.props.fetchOrdenesEncabezado(updatedFiltro);
    };

    updateRequest = (request) => {
        let params = { ...this.state, request: request };
        if (!this.allowSearchBySeller) {
            request.idSeller = this.props.idSeller;
            params = { ...this.state, request: request }
        }

        this.setState({ request: params.request, currentPage: params.request.numeroPagina });
        this.props.setFiltroOrdenes(params.request);
        this.props.fetchOrdenesEncabezado(params.request);
    }

    goToPreviousPath = () => {
        this.props.resetOrdenes();
        const { pathReturn } = this.props.location.state;
        this.props.navigate(`${pathReturn}`);
    }

    updateFile = async (file, idSellerOrden) => {
        if (!file) {
            return;
        }

        const idSeller = idSellerOrden != null && idSellerOrden !== ''
            ? idSellerOrden
            : this.props.idSeller;

        if (idSeller == null || idSeller === '') {
            toast.error('No se pudo determinar el seller de la orden para la carga del comprobante.');
            return;
        }

        const base64 = await fileToBase64(file);
        this.setState({ comprobantesZip: base64 });

        try {
            let request = {
                IdSeller: idSeller,
                Filename: file.name ?? "",
                Filecontent: base64
            };

            postCargaMasivaComprobantesApi(request)
                .then((response) => {
                    const hasErrors = response.data?.HasErrors;
                    const totalOk = response.data?.ProcesadosOk;
                    const totalError = response.data?.ProcesadosConError;

                    if (hasErrors) {
                        toast.warning(`Carga completada: ${totalOk} ok, ${totalError} con error`);
                        if (Array.isArray(response.data?.Errors)) {
                            response.data.Errors.forEach(err => {
                                const mensaje = err.IdOrden
                                    ? `Orden ${err.IdOrden}: ${err.ErrorMesage}`
                                    : err.ErrorMesage;
                                toast.error(mensaje);
                            });
                        }
                    } else {
                        toast.success(`${totalOk} archivo(s) cargado(s) exitosamente`);
                    }
                })
                .catch((error) => {
                    const errores = error?.response?.data?.errores;

                    if (Array.isArray(errores)) {
                        errores.forEach(err => {
                            // Si err es un objeto con idOrden y errorMesage
                            if (typeof err === 'object' && err.errorMesage && err.idOrden) {
                                toast.error(`Orden ${err.idOrden}: ${err.errorMesage}`);
                            } else if (typeof err === 'object' && err.errorMesage) {
                                // Solo tiene errorMesage
                                toast.error(err.errorMesage);
                            } else if (typeof err === 'string') {
                                // Si err es un string simple
                                toast.error(err);
                            } else {
                                toast.error(JSON.stringify(err));
                            }
                        });
                    } else if (error?.response?.status === 400) {
                        toast.error("Solicitud inválida. Verifica los datos del archivo.");
                    } else {
                        toast.error("Error al subir el archivo");
                    }

                });
        } catch (e) {
            toast.error("Archivo inválido");
        }
    };

    render() {
        const { userType, ordenes, loadingOrdenes } = this.props;
        const { isAdminMod, isCategory, isSoloLectura } = userType;
        const showCargaComprobanteLista = (isCategory || isAdminMod) && !isSoloLectura;
        const elementos = Array.isArray(ordenes?.elementos) ? ordenes.elementos : [];
        const visibleOrdenes = elementos.filter((orden) => (
            (this.props.idSeller === orden?.seller?.codigo && !isAdminMod) ||
            isCategory || isAdminMod || isSoloLectura
        ));
        const pageCount = Math.max(0, Math.ceil((Number(this.props.ordenes?.cantidadTotal) || 0) / 10));
        const forcePageRaw = (Number(this.props.filtro?.numeroPagina) || 1) - 1;
        const safeForcePage = Math.min(Math.max(forcePageRaw, 0), Math.max(pageCount - 1, 0));

        const totalizadores = [
            { nombre: 'Total Ventas', valor: '$' + formatoDecimal(ordenes.montoVentasTotal ?? 0) },
            { nombre: 'Total Ventas Anuladas', valor: '$' + formatoDecimal(ordenes.montoTotalVentasAnuladas ?? 0) },
            { nombre: 'Total Comisión', valor: '$' + formatoDecimal(ordenes.montoComisionTotal ?? 0) },
            { nombre: 'Cantidad Órdenes', valor: ordenes.cantidadTotal ?? 0 },
        ]


        return (
            <div className="container">
                <div className="row justify-content-between align-items-center page-titles text-center text-md-start">

                    <div className="col-12 col-md-2 mb-md-0 mb-2">
                        <h3 className="text-themecolor color-rojo-megatone">Órdenes</h3>
                    </div>

                    {!isSoloLectura &&
                        <div className="col-12 col-md-auto list-group list-group-horizontal-md">
                            {totalizadores.map((totalizador, index) => {
                                return (
                                    <div key={totalizador.nombre} className="list-group-item text-center">
                                        <span className="font-size-073rem d-block pb-1">{totalizador.nombre}</span>
                                        <span className="badge rounded-pill text-bg-primary">{totalizador.valor ?? 0}</span>
                                    </div>
                                )
                            })
                            }
                        </div>
                    }

                    {this.props.filtro.desdePublicacion ? '' :
                        <BtnToggleFilter show={this.state.onFilter} handleShow={() => this.setState({ onFilter: !this.state.onFilter })} />
                    }

                    {!this.props.filtro.desdePublicacion ? '' :
                        <div className="col-12 col-md-auto d-inline text-center text-md-end mt-md-0 mt-2">
                            <button
                                onClick={this.goToPreviousPath}
                                className="btn btn-sm btn-grey d-inline"
                            >
                                Volver
                            </button>
                        </div>
                    }

                </div>

                <div hidden={!this.state.onFilter}>
                    <FiltroOrdenes
                        filtro={this.props.filtro}
                        updateRequest={this.updateRequest}
                        allowSearchBySeller={isCategory || isSoloLectura || isAdminMod}
                    />
                </div>

                {loadingOrdenes ? <BigSpinner /> :
                    <div>
                        {visibleOrdenes.length > 0 ?
                            <div className="list-group">
                                {visibleOrdenes.map((orden, index) => {
                                    const idSellerOrden = orden.seller?.codigo;
                                    const uploadColumn = (
                                        <div
                                            className="flex-shrink-0"
                                            style={{
                                                width: 148,
                                                minWidth: 148,
                                                padding: 6,
                                                background: 'linear-gradient(180deg, #fafbfc 0%, #f4f6f8 100%)',
                                                border: '1px solid #e8eaed',
                                                borderRadius: 8,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'stretch',
                                                justifyContent: 'center',
                                            }}
                                            onClick={(e) => e.stopPropagation()}
                                            onMouseDown={(e) => e.stopPropagation()}
                                        >
                                            <UploadFileOrdenes
                                                inputId={`upload-orden-${orden.idOrden}`}
                                                acceptType=".pdf"
                                                onFileLoaded={(f) => this.updateFile(f, idSellerOrden)}
                                                style={{
                                                    width: '100%',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                }}
                                            />
                                        </div>
                                    );

                                    if (this.props.idSeller === orden.seller.codigo && !isAdminMod) {
                                        return (
                                            <div key={orden.idOrden ?? index} style={{ display: 'flex', gap: '8px', alignItems: 'stretch', flexWrap: 'wrap' }} onClick={(e) => { if (e.target.tagName !== 'INPUT') this.onOrden(orden.idOrden) }}>
                                                {uploadColumn}

                                                <div style={{ flex: '1 1 0', minWidth: 0 }}>
                                                    <OrdenListItem
                                                        mailCliente={""}
                                                        idOrden={orden.idOrden}
                                                        idReferencia={orden.idReferencia}
                                                        seller={orden.seller.descripcion}
                                                        fecha={orden.fecha}
                                                        cliente={orden.cliente.nombre + ' ' + orden.cliente.apellido}
                                                        documento={orden.cliente.documento}
                                                        tipoEntrega={orden.entrega.tipoEntrega.descripcion}
                                                        montoVenta={orden.montoVenta}
                                                        productos={orden.productos}
                                                        estado={orden.estado}
                                                        cuotas={orden.pago?.cuotas}
                                                        tarjeta={orden.pago?.tarjeta}
                                                        urlLogo={orden.seller.urlLogo}
                                                        anulacionMegatone={orden.anulacionMegatone}
                                                        showComision={false}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    } else if (showCargaComprobanteLista) {
                                        return (
                                            <div key={orden.idOrden ?? index} style={{ display: 'flex', gap: '8px', alignItems: 'stretch', flexWrap: 'wrap' }}>
                                                {uploadColumn}
                                                <div style={{ flex: '1 1 0', minWidth: 0 }}>
                                                    <button
                                                        type="button"
                                                        onClick={() => { this.onOrden(orden.idOrden) }}
                                                        className="btn btn-link p-0 m-0 text-start w-100 text-decoration-none"
                                                        style={{ color: 'inherit', minWidth: 0 }}
                                                    >
                                                        <OrdenListItem
                                                            idOrden={orden.idOrden}
                                                            idReferencia={orden.idReferencia}
                                                            seller={orden.seller.descripcion}
                                                            fecha={orden.fecha}
                                                            cliente={orden.cliente.nombre + ' ' + orden.cliente.apellido}
                                                            mailCliente={orden.cliente.email}
                                                            documento={orden.cliente.documento}
                                                            tipoEntrega={orden.entrega.tipoEntrega.descripcion}
                                                            montoVenta={orden.montoVenta}
                                                            productos={orden.productos}
                                                            estado={orden.estado}
                                                            cuotas={orden.pago?.cuotas}
                                                            tarjeta={orden.pago?.tarjeta}
                                                            urlLogo={orden.seller.urlLogo}
                                                            dniIdBocaSeller={orden.idVendedorBoca}
                                                            plataformaCodigo={orden.plataforma.codigo}
                                                            importeComision={orden.montoComision}
                                                            anulacionMegatone={orden.anulacionMegatone}
                                                            showComision={true}
                                                        />
                                                    </button>
                                                </div>
                                            </div>
                                        )
                                    } else if (isCategory || isAdminMod || isSoloLectura) {
                                        return (
                                            <div key={orden.idOrden ?? index} style={{ display: 'flex', gap: '8px', alignItems: 'stretch', flexWrap: 'wrap' }}>
                                                <button
                                                    type="button"
                                                    onClick={() => { this.onOrden(orden.idOrden) }}
                                                    className="btn btn-link p-0 m-0 text-start w-100 text-decoration-none"
                                                    style={{ flex: '1 1 0', minWidth: 0, color: 'inherit' }}
                                                >
                                                    <OrdenListItem
                                                        idOrden={orden.idOrden}
                                                        idReferencia={orden.idReferencia}
                                                        seller={orden.seller.descripcion}
                                                        fecha={orden.fecha}
                                                        cliente={orden.cliente.nombre + ' ' + orden.cliente.apellido}
                                                        mailCliente={orden.cliente.email}
                                                        documento={orden.cliente.documento}
                                                        tipoEntrega={orden.entrega.tipoEntrega.descripcion}
                                                        montoVenta={orden.montoVenta}
                                                        productos={orden.productos}
                                                        estado={orden.estado}
                                                        cuotas={orden.pago?.cuotas}
                                                        tarjeta={orden.pago?.tarjeta}
                                                        urlLogo={orden.seller.urlLogo}
                                                        dniIdBocaSeller={orden.idVendedorBoca}
                                                        plataformaCodigo={orden.plataforma.codigo}
                                                        importeComision={orden.montoComision}
                                                        anulacionMegatone={orden.anulacionMegatone}
                                                        showComision={true}
                                                    />
                                                </button>
                                            </div>
                                        )
                                    }
                                })
                                }
                            </div>
                            :
                            <h5 className="d-flex justify-content-center my-4">NO SE ENCONTRARON RESULTADOS</h5>
                        }
                    </div>
                }

                <div className="d-flex justify-content-center">
                    <ReactPaginate
                        previousLabel={"Anterior"}
                        nextLabel={"Siguiente"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={pageCount}
                        marginPagesDisplayed={5}
                        pageRangeDisplayed={10}
                        onPageChange={this.handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        forcePage={safeForcePage}
                    />
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    userType: state.general.userType,
    idSeller: state.general.idSeller,
    loadingOrdenes: state.ordenes.loadingOrdenes,
    emptyFiltro: state.general.limpiar,
    ordenes: state.ordenes.ordenes,
    filtro: state.ordenes.filtro
});

export default withNavigation(connect(mapStateToProps, {
    fetchOrdenesEncabezado,
    limpiarFiltros,
    setFiltroOrdenes,
    fetchSellersFilter,
    resetOrdenes,
})(ListOrdenesWrapper));
